import { BaseFieldRenderer } from './base-field-renderer';
import { SignatureFieldJsonData, RenderOptions } from '../../models/element-types';
import { TranslateUtils } from '../../utils/translate.utils';

export class SignatureFieldRenderer extends BaseFieldRenderer<SignatureFieldJsonData> {
    protected override get defaultData(): SignatureFieldJsonData {
        return {
            id: '',
            type: 'signature',
            label: TranslateUtils.SIGNATURE_FIELD.LABEL,
            placeholder: TranslateUtils.SIGNATURE_FIELD.PLACEHOLDER,
            clearButton: TranslateUtils.SIGNATURE_FIELD.CLEAR_BUTTON,
            required: true,
            hiddenLabel: false
        };
    }

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    protected override renderContent(fieldJsonData: SignatureFieldJsonData, options: RenderOptions = {}): HTMLElement {
        const elementContent = document.createElement('div');
        elementContent.classList.add('element-content');

        const fieldContainer = document.createElement('div');
        fieldContainer.classList.add('field');
        fieldContainer.classList.toggle('required', fieldJsonData.required);

        if (!fieldJsonData.hiddenLabel) {
            const label = this.renderLabel(fieldJsonData);
            fieldContainer.appendChild(label);
        }

        const canvasContainer = document.createElement('div');
        canvasContainer.classList.add('signature-placeholder');
        canvasContainer.classList.toggle('required', fieldJsonData.required);

        if (fieldJsonData.height) {
            canvasContainer.style.height = `${fieldJsonData.height}px`;
        }

        const canvas = document.createElement('canvas');
        canvas.classList.add('canvas');
        canvas.id = `field-${fieldJsonData.id}-canvas`;
        canvas.setAttribute('aria-label', fieldJsonData.placeholder || TranslateUtils.SIGNATURE_FIELD.PLACEHOLDER);

        const overlay = document.createElement('div');
        overlay.classList.add('overlay');

        const overlayText = document.createElement('span');
        overlayText.classList.add('overlay-text');
        overlayText.textContent = fieldJsonData.placeholder || TranslateUtils.SIGNATURE_FIELD.PLACEHOLDER;

        const overlaySignature = document.createElement('span');
        overlaySignature.classList.add('overlay-signature');

        overlay.append(overlayText, overlaySignature);

        canvasContainer.append(canvas, overlay);

        const errorContainer = this.renderErrorContainer(fieldJsonData);

        const clearLink = document.createElement('a');
        clearLink.classList.add('signature-clear');
        clearLink.textContent = fieldJsonData.clearButton || TranslateUtils.SIGNATURE_FIELD.CLEAR_BUTTON;
        clearLink.href = 'javascript:void(0)';

        const input = this.renderInput(fieldJsonData, options);
        fieldContainer.append(canvasContainer, errorContainer, clearLink, input);

        if (fieldJsonData.showDescription) {
            const description = this.renderDescription(fieldJsonData);
            fieldContainer.appendChild(description);
        }

        elementContent.appendChild(fieldContainer);

        return elementContent;
    }

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    protected renderInput(fieldJsonData: SignatureFieldJsonData, options: RenderOptions): HTMLElement {
        const input = document.createElement('input');
        input.classList.add('input');
        input.id = `field-${fieldJsonData.id}`;
        input.type = 'file';
        input.name = fieldJsonData.id;
        input.accept = 'image/png';
        input.hidden = true;
        input.tabIndex = -1;
        input.setAttribute('aria-hidden', 'true');
        if (fieldJsonData.required) {
            input.required = true;
        }
        const plainLabel = this.getPlainLabel(fieldJsonData.label);
        if (plainLabel) {
            input.dataset['label'] = plainLabel;
        }

        return input;
    }
}
